import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'gatsby-plugin-intl'
import Layout from '@layouts/Layout'
import { Section1 } from '@templates/about-us'
import Jumbotron from '@components/jumbotron/Jumbotron'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

const AboutUs = props => {
  const { formatMessage } = useIntl()
  const { pageContext } = props
  const { languageName } = pageContext

  return <Layout languageName={languageName} pageContext={pageContext}>
    <Jumbotron
      icon={faInfoCircle}
      title={formatMessage({ id: 'about-us' })}
      description=''
    />
    <div className='row'>
      <Section1 className='col-md-12'>
          About us
      </Section1>
    </div>
  </Layout>
}

AboutUs.propTypes = {
  pageContext: PropTypes.any
}

export default AboutUs
